import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';

class AdminAccountingPayinRoute extends Route {
  /**
   * Setting these params to reload the route when they are changed.
   *
   * @inheritDoc
   */
  get queryParams() {
    return {
      id: {
        refreshModel: true,
      },
      approved: {
        refreshModel: true,
      },
      agreement: {
        refreshModel: true,
      },
      applicationId: {
        refreshModel: true,
      },
      batch: {
        refreshModel: true,
      },
      companyId: {
        refreshModel: true,
      },
      final_status: {
        refreshModel: true,
      },
      sent_status: {
        refreshModel: true,
      },
      sort: {
        refreshModel: true,
      },
      unpaid: {
        refreshModel: true,
      },
      overpaid: {
        refreshModel: true,
      },
      exact: {
        refreshModel: true,
      },
      partial: {
        refreshModel: true,
      },
      stripe: {
        refreshModel: true,
      },
      invoice: {
        refreshModel: true,
      },
      revised_status: {
        refreshModel: true,
      },
    };
  }

  /**
   * Register services
   */
  @service('states/routes/admin/accounting/payin') state;
  @service('state-managers/routes/admin/accounting/payin') stateManager;

  /**
   * @inheritDoc
   */
  model(params) {
    this.stateManager.resetToBasePage();

    let controller = this.controllerFor('admin.accounting.payin.index');
    controller.updateStateFromParams(params);

    return this.stateManager.loadShInvoices(
      this.state.page,
      controller.count,
      controller.getNewFilter(params),
      this.state.paramSort
    );
  }
}

export default AdminAccountingPayinRoute;
